import type { UserJwConsents } from '@/stores/useUserStoreTypes';

import { getAxios } from '@/helpers/axios-helper';
import { hasDoNotTrack } from '@/helpers/consent-helper';

const WebPlatform = 3 as const;

export async function getIdServiceVariables(jwId: string | null, consents: UserJwConsents) {
	const dnt = hasDoNotTrack(false, consents);
	return { dnt, ids: [jwId].filter(Boolean).join(',') };
}

export async function updateUserProfile(jwId: string | null, country: string, language: string, pushToken?: string) {
	const profile = {
		geoip_country: 'XX',
		app_country: country.toUpperCase(),
		device_language: language,
		utc_offset_minutes: new Date().getTimezoneOffset(),
		push_token: pushToken !== undefined ? pushToken : null,
		push_allowed: pushToken !== undefined ? !!pushToken : null,
		token_platform: null,
	};

	// remove null values
	for (const propName in profile) {
		if (profile[propName as keyof typeof profile] === null) {
			delete profile[propName as keyof typeof profile];
		}
	}

	try {
		await getAxios().post(`${JW_CONFIG.ID_URL}/s`, { id: jwId, profile }, { params: { a: WebPlatform } });
	} catch (error: any) {
		const status = error.response?.status ?? error.message ?? 'The request was made but no response was received';
		throw new Error(`${error.config.url}: ${status}`, { cause: error });
	}
}
